module.exports = __webpack_public_path__ + "media/pages/Home/images/InHouseChef-68cf29fa6b48d3b651e40067f947c210.jpg";